import { credentials } from '../data/portfolioData';

export const Credentials = ({ isVisible }) => (
  <section id="credentials" className={`credentials ${isVisible ? 'fade-in' : ''}`}>
    <div className="sec-head">
      <span className="kicker">◆ 05 · TROPHIES</span>
      <h2>Paperwork, but <em>fun</em>.</h2>
    </div>

    <div className="cred-grid">
      {credentials.map((c, i) =>
        c.big ? (
          <article key={i} className="cred-card big">
            <div className="cred-ribbon">{c.ribbon}</div>
            <h3>{c.title}</h3>
            <p className="cred-sub">{c.sub}</p>
            <div className="cred-meta">
              {c.meta.map((m) => (
                <div key={m.key}>
                  <b>{m.key}</b>
                  <span>{m.val}</span>
                </div>
              ))}
            </div>
            <div className="cred-thesis">
              <b>Thesis —</b> {c.thesis}
            </div>
          </article>
        ) : (
          <article key={i} className="cred-card" style={{ '--cc': c.color }}>
            <div className="cred-corner">{c.corner}</div>
            <h3>{c.title}</h3>
            <p className="cred-sub">{c.sub}</p>
            <div className="cred-date">{c.date}</div>
          </article>
        )
      )}
    </div>
  </section>
);
